module.exports = __webpack_public_path__ + "static/img/brand_5.9c98e5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/brand_5.jpg
// module id = JaI6
// module chunks = 1